/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, Highcharts, mp */

// For inheriting you'll need to implement get_new_version, get_previous_version
// and set:
//   slug, nice_name, description
//
_.namespace(`mp.marketing.trends.widgets`, function(ns) {
  'use strict';
  var TimeRangeViewer = mp.marketing.trends.TimeRangeViewer;

  ns.OSAdoption = mp.marketing.trends.widgets.TrendReport.extend({
    get_defaults() {
      var release_dates = this.get_new_version().release_dates;
      var latest_release = release_dates[release_dates.length - 1].value;
      var latest_time = latest_release.getTime();
      var start_date = new Date(latest_time - (14 * 24 * 60 * 60 * 1000));
      var end_date = new Date(latest_release.getTime() + (90 * 24 * 60 * 60 * 1000));
      var today = new Date();
      end_date = end_date > today ? today : end_date;
      var range = new DateRange(start_date, end_date);
      return {
        date_range: range,
        report_unit: range.days() > 30 ? `week` : `day`,
      };
    },

    get_new_version() {
      throw new Error(`UNIMPLEMENTED`);
    },

    get_previous_version() {
      throw new Error(`UNIMPLEMENTED`);
    },

    get_query_name() {
      return mp.marketing.trends.utils.IOS_QUERY;
    },

    get_queries() {
      var unit = this.session.get(`report_unit`);
      var date_range = this.session.get(`date_range`);

      return {
        base: {
          'query_name': this.get_query_name(),
          unit,
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
        },
      };
    },

    get_chart_params(query_data) {
      delete query_data.base.Unknown;

      var new_version = this.get_new_version();
      var previous_version = this.get_previous_version();

      var parse_date = function(date_string) {
        var date = Date.parseExact(date_string, `yyyy-MM-dd HH:mm:ss`) ||
                       Date.parseExact(date_string, `yyyy-MM-dd`);
        // dates from arb are in PST (project time)
        date.setTimezone(`PST`);
        return date;
      };

      var data = {
        'Older': {},
      };
      data[previous_version.name] = {};
      data[new_version.name] = {};

      var totals = {};
      _.each(query_data.base, function(dates, os_version) {
        var recipient = `Older`;
        if (os_version.match(previous_version.regex)) {
          recipient = previous_version.name;
        } else if (os_version.match(new_version.regex)) {
          recipient = new_version.name;
        }

        _.each(dates, function(value, date) {
          if (parse_date(date).getTime() < mp.report.globals.utc_now) {
            if (!(date in data[recipient])) {
              data[recipient][date] = 0;
            }
            if (!(date in totals)) {
              totals[date] = 0;
            }
            data[recipient][date] += value;
            totals[date] += value;
          }
        }, this);
      }, this);

      var color_idx = -1;
      var new_version_color;
      var chart_data = _.map(data, function(dates_values, name) {
        color_idx++;
        if (name === new_version.name) {
          new_version_color = color_idx;
        }
        return {
          name,
          color: mp.charts.nth_color(color_idx, this.color_scheme),
          data: _.map(dates_values, function(val, date) {
            var unixtime = parse_date(date).setTimezone(`US/Pacific`).getTime();
            var percent = 0;
            if (totals[date]) {
              percent = (val / totals[date]) * 100;
            }
            return [ unixtime, percent ];
          }, this).sort(function(a, b) {
            return a[0] - b[0];
          }),
        };
      }, this);

      var xaxis_config;
      if (this.session.get(`report_unit`) === `hour`) {
        xaxis_config = {
          type: `datetime`,
          tickInterval: 4 * 60 * 60 * 1000, // 4 hrs
          labels: {
            formatter() {
              return Highcharts.dateFormat(`%b. %e, %l %p`, this.value);
            },
            rotation: -45,
          },
        };
      } else {
        xaxis_config = {
          type: `datetime`,
          minTickInterval: 24 * 60 * 60 * 1000, // 24 hrs
          labels: {
            formatter() {
              return Highcharts.dateFormat(`%b. %e`, this.value);
            },
            rotation: -45,
          },
        };
      }

      var os_release_dates = new_version.release_dates;

      xaxis_config.plotLines = _.map(os_release_dates, function(os_release_date) {
        return {
          value: os_release_date.value,
          color: mp.charts.nth_color(new_version_color, this.color_scheme),
          width: 1,
          zIndex: 2,
          label: {
            text: new_version.name + ` ` + os_release_date.text,
            verticalAlign: `middle`,
            textAlign: `center`,
          },
        };
      }, this);

      return {
        xAxis: xaxis_config,
        yAxis: {
          labels: {
            formatter() {
              return this.value + `%`;
            },
          },
        },
        series: chart_data,
        tooltip: {
          shared: true,
          crosshairs: true,
          backgroundColor: `rgba(255, 255, 255, 1)`,
          borderWidth: 1,
          useHTML: false,
          pointFormat: `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>`,
          valueDecimals: 2,
        },
        chart: {marginBottom: 75, height: 450},
        plotOptions: {
          line: {animation: {duration: 400}},
        },
      };
    },
  });

  Object.assign(ns.OSAdoption, {
    chart_type: `line`,
    color_scheme: `colorblind`,
    asterisk: `Time/Date in UTC`,
    view_class: TimeRangeViewer,
    time_units: [`hour`, `day`, `week`],
  });
});

}.call(window));